import { sendAnalyticsEvent } from './sendGAAnalyticsEvent'

let deferredPrompt = null

window.addEventListener('beforeinstallprompt', e => {
    console.log('[installPwa] beforeinstallprompt fired!')
    e.preventDefault()
    deferredPrompt = e
})
export const promptHandler = () => {
    return Promise.resolve(!!deferredPrompt)
}

const sendPwaInstallAnalytics = user => {
    sendAnalyticsEvent('pwa_install', {
        install_time: new Date().toISOString(),
        device: navigator.userAgent,
        company_name: user?.company?.name,
        server: process.env.MIX_APP_ENV,
        user_salesforce_id: user?.external_contact_id,
    })
}

export const installPWA = user => {
    if (!deferredPrompt) {
        console.log('No install prompt available')
        return false
    }

    deferredPrompt.prompt()
    deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
            sendPwaInstallAnalytics(user)
        } else {
            console.log('User dismissed the PWA installation')
        }
        deferredPrompt = null
    })
    return true
}
